var map = {
	"./caiwu.svg": 42390,
	"./chunbo.svg": 97676,
	"./dashboard.svg": 4679,
	"./dingdan.svg": 55242,
	"./editIcon.svg": 89594,
	"./example.svg": 21649,
	"./eye-open.svg": 12429,
	"./eye.svg": 95628,
	"./fenzhang.svg": 52178,
	"./form.svg": 3771,
	"./fuwu.svg": 13062,
	"./geren.svg": 13676,
	"./gongzuotai.svg": 33802,
	"./jichu.svg": 75696,
	"./jinhuo.svg": 36896,
	"./kucun.svg": 51485,
	"./link.svg": 81445,
	"./nested.svg": 85016,
	"./password.svg": 39902,
	"./pingtaishangpin.svg": 99125,
	"./rmb.svg": 61256,
	"./shangpin.svg": 79205,
	"./shangpu.svg": 56421,
	"./shenhe.svg": 37492,
	"./shenhezhongxin.svg": 55645,
	"./shezhi.svg": 71900,
	"./shezhitubiao.svg": 60718,
	"./shouye.svg": 29334,
	"./table.svg": 54383,
	"./tixian.svg": 8596,
	"./tree.svg": 92701,
	"./user.svg": 68848,
	"./xiaoshou.svg": 32173,
	"./yaopin.svg": 95783,
	"./zhensuo.svg": 48889,
	"./zizhi.svg": 85461,
	"./zuzhiIcon.svg": 61182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;